import { Component } from '@angular/core'

@Component({
  selector: 'app-rate-push-automations',
  templateUrl: './rate-push-automations.component.html',
  styleUrls: ['./rate-push-automations.component.scss'],
})
export class RatePushAutomationsComponent {}
